

















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import PermissionRole from './PermissionRole.vue'
import PermissionAccount from './PermissionAccount.vue'

import { YKDRightDrawer } from 'gum-ui'

@Component({
  components: { PermissionRole, PermissionAccount, YKDRightDrawer }
})
export default class PermissionDetail extends Vue {
  @Prop() visible?: boolean

  rightDrawClose() {
    this.$emit('close')
  }
}
